<template>
  <div style="display: flex;
    flex-wrap: wrap;
    justify-content: center;">
    <!-- <div> -->

    <img src="../assets/lxw/lx_02.jpg" class="fruit_img" />
    <!-- <img src="../assets/lxw/lx_03.jpg" style="width: 1920px;" /> -->
    <div>
      <img src="../assets/lxw/lx.jpg" style="position: relative;width: 1920px;" />
      <div style=" position: relative; display: flex;justify-content: center;top: -789px;left: 300px;">
        <div style="margin-right: 28px;margin-left: -92px; text-align: center;">
          <div><img src="../assets/gw.png" style="width: 100px;height: 100px;border: 0" /></div>
          <div class="footer_font">襄阳澜鲸文化传媒有限公司</div>
        </div>
        <div style="text-align: center;">
          <div><img src="../assets/cxm.jpg" style="width: 100px;height: 100px;border: 0" /></div>
          <div class="footer_font">曹经理</div>
          <div style="position: relative;left: -86px;">
            长按保存图片 &nbsp&nbsp&nbsp扫一扫咨询
          </div>
        </div>
      </div>
    </div>

    <img src="../assets/lxw/lx_05.jpg" style="width: 1920px;" />
    <div style="background-color: #fafafc; height: 45px;width: 1920px;display: inline-block;"></div>
  </div>
</template>
<script>
export default {
  name: 'Fruit',
  data() {
    return {
      delivery: [
        {
          img: require('../assets/other/定位图标.png'),
          title: "自定义配送范围",
          contents: ["商家后台自定义配送范围"]
        }, {
          img: require('../assets/other/骑车送.png'),
          title: "支持自定义配送",
          contents: ["商家自己优选配送路径"]
        }, {
          img: require('../assets/other/券.png'),
          title: "线上优惠券福利",
          contents: ["各种优惠福利提升用户消费"]
        }
      ]
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.lis {
  position: relative;
  width: 230px;
  height: 70px;
  font-size: 22px;
}

.lis:hover {
  background-color: #1E9FFF;
  color: #fff;
}

.zxls {
  margin-top: 60px;
  width: 1920px;
  background: #fafafc;
}

.delivery_border {
  height: auto;
  margin: 20px;
  width: 55%;
  /*border-radius: 6px;*/
  /*border: 1px solid #EBEEF5;*/
}

.zu {
  width: 1920px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;
}

.zuone {
  width: 682px;
  height: 285px;
  margin-top: 32px;
}

.zuw {
  width: 682px;
  height: 285px;
  margin-right: 18px;
  margin-top: 18px;
}

.delivery_border_img {
  margin-top: 20px;
  width: 70px;
  height: 70px;
}

.delivery_border_title {
  margin-top: 10px;
  font-size: 1.25em;
  font-weight: normal;
}

.delivery_border_content {
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: normal;
}

.fruit_img {
  margin-top: 64px;
  width: 1920px;
  height: 674px;
}

.fruit_product_img {
  height: 500px;
  width: 260px;
}

.deliver_parent {
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.deliver_img_parent {
  width: 30%;
  height: auto;
}

.delivery {
  display: flex;
  height: 550px;
  width: 1281px;
  margin: auto;
  justify-content: center;
  align-items: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .fruit_img {
    height: 250px;
    width: 100%;
  }

  .fruit_product_img {
    height: 400px;
    width: 240px;
  }

  .delivery_border_img {
    margin-top: 20px;
    width: 70px;
    height: 70px;
  }

  .deliver_img_parent {
    width: 100%;
    float: left;
    height: 400px;
  }

  .deliver_parent {
    float: left;
    margin-top: 5px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .delivery_border {
    height: auto;
    margin: 10px 0 auto;
    width: 100%;
    float: right;
    border-radius: 6px;
    border: 1px solid #EBEEF5;
  }

  .delivery {
    display: flex;
    width: 1281px;
    height: auto;
    margin: auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .delivery_border_title {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
  }

  .delivery_border_content {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
    margin-bottom: 10px;
  }
}
</style>